
import { BCMSRecord, useGlobalController, useParams, useRouteData } from "@bcm-dev/bcms-vite";
import React from "react";

import PageLayoutContainer from "compid/shared/containers/PageLayoutContainer";
import LeftColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/LeftColumnContainer";
import RightColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/RightColumnContainer";
import InfoNotificationView from "compid/shared/views/Notifications/InfoNotificationView";
import SuccessNotificationView from "compid/shared/views/Notifications/SuccessNotificationView";
import { Account, Autopay, Bill, Biller, Payment, Reminder } from "model";
import { BillerActivityWidget, BillerDetailsWidget } from "../..";
import BillerDetailsEditConfirmation from "../BillerDetailsEditConfirmation";
import "./styles.css";

/**
 * @function BillerDetailsDesktopView
 * @return {React.Component}
 * @exported true
 * @description This is the component that displays the desktop layout for the BillerDetailsPage.
 */
export default function BillerDetailsDesktopView(props) {
  const { route } = useRouteData();
  const controller = useGlobalController();
  const { id } = useParams();

  BCMSRecord.globalControllerFor([ Biller, Account, Payment, Bill, Autopay, Reminder ], controller);
  // Replace the state so it doesn't persist on a page reload
  window.history.replaceState({}, document.title);

  const markedBillAsPaid = route === null ? false : route.markedBillAsPaid;
  const hasRouteData = route ? true : false;

  let successMessage = markedBillAsPaid ? "You have successfully marked your bill as paid." : undefined;

  if(hasRouteData) {
    if(route.autopayDeleted === "true") {
      successMessage = Autopay.getAutopaySuccessMessage(route);
    }
  }

  let biller = id !== undefined ? Biller.initByID(id) : Biller.firstBiller(controller.state);
  biller = biller !== undefined ? biller : Biller.firstBiller(controller.state);

  return(
    <div className="biller-details-desktop-view">
      <PageLayoutContainer>
        <LeftColumnContainer>
          { biller.paymentType === "instantPayment" && <InfoNotificationView text="Same-day payment delivery is available." icon="ZapIcon" className="same-day-notification" /> }
          { biller.paymentType === "withinMinutes" && <InfoNotificationView text="Payment delivery within minutes is available" icon="ZapIcon" className="within-minutes-notification" /> }

          <BillerDetailsEditConfirmation />
          { successMessage !== undefined && <SuccessNotificationView message={ successMessage } showClose={ false }/> }
          <BillerDetailsWidget />
        </LeftColumnContainer>

        <RightColumnContainer>
          <BillerActivityWidget />
        </RightColumnContainer>
      </PageLayoutContainer>
    </div>
  );
}